import { Box } from '@mui/material';
import { marked } from 'marked';

interface MarkdownRendererProps {
  content: string;
}

export default function MarkdownRenderer({ content }: MarkdownRendererProps) {
  const html = marked(content, { breaks: true });

  return (
    <Box
      dangerouslySetInnerHTML={{ __html: html }}
      sx={{
        '& h1, & h2, & h3, & h4, & h5, & h6': {
          fontFamily: '"Roboto Condensed", sans-serif',
          fontWeight: 600,
          color: 'text.primary',
          mt: 3,
          mb: 1,
        },
        '& h1': { fontSize: '2rem' },
        '& h2': { fontSize: '1.5rem' },
        '& h3': { fontSize: '1.25rem' },
        '& h4': { fontSize: '1.1rem' },
        '& h5': { fontSize: '1rem' },
        '& h6': { fontSize: '0.9rem' },
        '& p': {
          fontSize: '1rem',
          lineHeight: 1.6,
          color: 'text.primary',
          mb: 2,
        },
        '& a': {
          color: 'primary.main',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
        '& ul, & ol': {
          fontSize: '1rem',
          color: 'text.primary',
          ml: 2,
          mb: 2,
        },
        '& li': {
          mb: 0.5,
        },
        '& img': {
          maxWidth: '100%',
          height: 'auto',
          borderRadius: 1,
          my: 2,
          boxShadow: 1,
        },
        '& blockquote': {
          borderLeft: '4px solid',
          borderColor: 'primary.main',
          pl: 2,
          py: 0.5,
          my: 2,
          color: 'text.secondary',
          fontStyle: 'italic',
        },
        '& code': {
          fontFamily: '"Roboto Mono", monospace',
          fontSize: '0.9em',
          backgroundColor: 'action.hover',
          px: 1,
          py: 0.25,
          borderRadius: 0.5,
          color: 'text.primary',
        },
        '& pre': {
          fontFamily: '"Roboto Mono", monospace',
          fontSize: '0.9rem',
          backgroundColor: 'action.hover',
          p: 2,
          borderRadius: 1,
          overflowX: 'auto',
          my: 2,
          '& code': {
            backgroundColor: 'transparent',
            px: 0,
            py: 0,
          },
        },
        '& hr': {
          borderStyle: 'dotted',
          borderColor: 'divider',
          my: 3,
        },
        '& table': {
          width: '100%',
          borderCollapse: 'collapse',
          my: 2,
        },
        '& th, & td': {
          border: '1px solid',
          borderColor: 'divider',
          padding: 1,
          textAlign: 'left',
        },
        '& th': {
          backgroundColor: 'action.hover',
          fontWeight: 600,
        },
      }}
    />
  );
}
